import React from "react";
import PropTypes from "prop-types";
import styles from "./StatsPanelPercentageBar.module.scss";

const StatsPanelPercentageBar = ({
  probability,
  numberOfMatches,
  numberOfWins,
  type,
}) => {
  return (
    <div
      className={styles.statsPercentageBar}
      data-testid={`stats-panel-percentage-${type}`}
    >
      <div className={styles.statsProbability}>{probability}%</div>
      <div className={styles.statsMatchData}>
        {numberOfWins} out of {numberOfMatches} matches
      </div>
      <div className={styles.statsBar} data-testid={`stats-bar-${type}`}>
        <div
          className={styles.statsBar}
          style={{ width: `${probability}%`, background: "#009745" }}
          data-testid={`stats-bar-inner-${type}`}
        />
      </div>
    </div>
  );
};

StatsPanelPercentageBar.propTypes = {
  probability: PropTypes.number,
  numberOfMatches: PropTypes.number,
  numberOfWins: PropTypes.number,
  type: PropTypes.string,
};

export default StatsPanelPercentageBar;
